export default {
  methods: {
    $withoutWatchers (cb) {
      if (!this._watchers || !this._watchers.length) {
        // No watchers, just run the callback
        return cb()
      }

      // Make a shallow copy of existing watchers
      const watchers = this._watchers.map((watcher) => ({ cb: watcher.cb, sync: watcher.sync }))

      // Disable watchers temporarily
      for (const index in this._watchers) {
        this._watchers[index] = Object.assign(this._watchers[index], { cb: () => null, sync: true })
      }

      // Run the callback
      cb()

      // Restore watchers
      for (const index in this._watchers) {
        this._watchers[index] = Object.assign(this._watchers[index], watchers[index])
      }
    }
  }
}
